module.exports = __webpack_public_path__ + "img/alfa-logo.c96c3e3f.jpg";